import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'message-snackbar',
    templateUrl: './message-snackbar.component.html',
    styleUrls: ['./message-snackbar.component.scss'],
})
export class MessageSnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: any,
        private snackBarRef: MatSnackBarRef<MessageSnackbarComponent>
    ) {}

    onActionClick(): void {
        this.snackBarRef.dismiss();
    }
}
